import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import { render } from '@testing-library/react';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as firebase from 'firebase';
import firebaseConfig from "./config"
import { TwitterTimelineEmbed, TwitterShareButton, TwitterFollowButton, TwitterHashtagButton, TwitterMentionButton, TwitterTweetEmbed, TwitterMomentShare, TwitterDMButton, TwitterVideoEmbed, TwitterOnAirButton } from 'react-twitter-embed';

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

class App extends Component{
state={
  boucle: 1,
  etape: 1,
  result: null

}


  render(){



  return (

<div>
    <div className="logoHome container">
      <img className="logositehome" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/logo%2Fbleu.png?alt=media&token=e8395e1a-cf80-437f-bd42-c1aef99f239b"></img>
      <h3 className="titlehome">À qui ressembles-tu dans ton animé préféré ?</h3>
      <img className="chevrontitle" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/other%2Fchevron-down.svg?alt=media&token=c6fa6c88-2c09-4bde-81aa-2ea18fc65a1e"></img>
      <label className="entrechevrontitle">Liste des animés disponibles</label>
      <img className="chevrontitle" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/other%2Fchevron-down.svg?alt=media&token=c6fa6c88-2c09-4bde-81aa-2ea18fc65a1e"></img>
    </div>



    <div class="container colcard">
  <div class="row">
    <div class="col-sm">
      
      <div className="card">
        <img className="imgcard" src="https://images.alphacoders.com/944/944924.png"></img>
        <h5 className="titlecard">Naruto</h5>
        <p className="descard">Plutôt Itachi ou Naruto ? Découvre à qui tu ressembles dans l'animé ! </p>
        <button  href="/Naruto" className="buttongo"><a href="/Naruto" style={{textDecoration: "none", color: "white"}}>Commencer <img className="imgbutton" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/other%2Fchevron-right%20(1).svg?alt=media&token=ec9b84b8-9dba-41a7-9b03-abbe5615c98c"></img></a></button>
      </div>




    </div>
    <div class="col-sm">

      <div className="card">
        <img className="imgcard" src="https://a-static.besthdwallpaper.com/haikyuu-karasuno-equipe-fond-d-ecran-3554x1999-15261_53.jpg"></img>
        <h5 className="titlecard">Haikyuu </h5>
        <p className="descard">Tu aimes le volley-ball ?? Tu aimes Haikyuu ?? Alors regarde à quel personnage ton profil Twitter est associé !</p>
        <button className="buttongo"><a href="/Haikyuu" style={{textDecoration: "none", color: "white"}}>Commencer <img className="imgbutton" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/other%2Fchevron-right%20(1).svg?alt=media&token=ec9b84b8-9dba-41a7-9b03-abbe5615c98c"></img></a></button>
      </div>
    </div>
  </div>
</div>





    </div>
  )}
}

export default App;
